import { getCookie, decryptAes, dateInterfere } from '../../../utils';

export default object => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return {
    id: null,
    type: object.type,
    number: object.number,
    year: object.year,

    sourceId: object.id,
    source: 'legislative',
    status: 'pending',
    description: `Lembrete ${object.type} - ${object.number}/${object.year}.`,
    notify: false,
    taskDate: dateInterfere({
      date: new Date(),
      quantity: 5,
      interval: 'days',
    }),
    participants: [decipher?.user?.id],
  }
};
